import * as React from 'react';
export const IcCowProfile = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14 15h-4a3 3 0 000 6h4a3 3 0 100-6zm4.75-6h-.14A7.31 7.31 0 0021 4a1 1 0 00-1.83-.56A11.45 11.45 0 0116.68 6 4.31 4.31 0 0014 5h-4a4.31 4.31 0 00-2.68 1 11.45 11.45 0 01-2.49-2.56A1 1 0 003 4a7.31 7.31 0 002.39 5h-.14A2.25 2.25 0 003 11.25a.76.76 0 00.75.75h1.5c.379-.002.75-.102 1.08-.29 0 .14.07.28.11.42.176.657.31 1.325.4 2A5 5 0 0110 13h4a5 5 0 013.16 1.15c.09-.675.224-1.343.4-2 0-.14.07-.28.11-.42.33.188.701.288 1.08.29h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 9zM9 11a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
